import { Method } from 'axios';
import {
  DOCUMENT_MANAGEMENT_BASE_URL,
  httpVerbs,
  MOBILITY_MANAGEMENT_BASE_URL,
  LOCATION_MANAGEMENT_BASE_URL,
} from 'configs';
import { IRecordId } from 'interfaces/general';
import request from 'utils/axios';
import { Mobility } from '../../types';
import { IParsedTransportVoucherResponse } from '../Transport/types';
import { MobilitiesResponse, MobilityData } from './types';
import { OverviewQueryParams } from '../../types';
import { AddressOutput } from 'utils/types';

const SEGMENT_MOBILITY_MANAGEMENT = `${MOBILITY_MANAGEMENT_BASE_URL}/api/v1`;
const SEGMENT_DOCUMENT_MANAGEMENT = `${DOCUMENT_MANAGEMENT_BASE_URL}/api/v1`;
const SEGMENT_LOCATION_MANAGEMENT = `${LOCATION_MANAGEMENT_BASE_URL}/api/v1`;

// Internal API place response includes additional fields like id
export interface InternalPlace extends AddressOutput {
  id?: number;
  timezone?: string;
  createdAt?: string;
}

export interface PlaceSearchResponse {
  success: boolean;
  data: InternalPlace[];
  message?: string;
  status?: number;
}

export const searchPlaces = (keyword: string): Promise<PlaceSearchResponse> => {
  const url = `${SEGMENT_LOCATION_MANAGEMENT}/place/search?keyword=${encodeURIComponent(keyword)}&placeTypes=AIRPORT&placeTypes=CAR_RENTAL&placeTypes=PASSENGER_ADDRESS`;
  return request({
    url,
    method: httpVerbs.GET as Method,
  });
};

export const parseMobilityVoucher = (
  data: FormData,
  signal?: AbortSignal,
): Promise<IParsedTransportVoucherResponse> => {
  const url = `${SEGMENT_DOCUMENT_MANAGEMENT}/documents/parse-trip-service-document`;
  return request({
    url,
    method: httpVerbs.POST as Method,
    data,
    signal,
  });
};

export const getMobilities = (
  agencyId: IRecordId,
  tripId: IRecordId,
  params?: OverviewQueryParams,
): Promise<MobilitiesResponse> => {
  const url = `${SEGMENT_MOBILITY_MANAGEMENT}/${agencyId}/trips/${tripId}/mobilities`;
  return request({
    url,
    method: httpVerbs.GET as Method,
    params,
  });
};

export const getSingleMobility = (
  mobilityId: IRecordId,
  agencyId: IRecordId,
  tripId: IRecordId,
): Promise<{ data: Mobility }> => {
  const url = `${SEGMENT_MOBILITY_MANAGEMENT}/${agencyId}/trips/${tripId}/mobilities/${mobilityId}`;
  return request({
    url,
    method: httpVerbs.GET as Method,
  });
};

export const updateMobility = (
  data: MobilityData,
  agencyId: IRecordId,
  tripId: IRecordId,
  mobilityId: IRecordId,
): Promise<{ success: boolean; message: string }> => {
  const url = `${SEGMENT_MOBILITY_MANAGEMENT}/${agencyId}/trips/${tripId}/mobilities/${mobilityId}`;
  return request({
    url,
    method: httpVerbs.PUT as Method,
    data,
  });
};

export const deleteMobility = (
  mobilityId: IRecordId,
  agencyId: IRecordId,
  tripId: IRecordId,
): Promise<{ success: boolean; message: string }> => {
  const url = `${SEGMENT_MOBILITY_MANAGEMENT}/${agencyId}/trips/${tripId}/mobilities/${mobilityId}`;
  return request({ url, method: httpVerbs.DELETE as Method });
};

export const addMobilityToTrip = (
  data: MobilityData,
  agencyId: IRecordId,
  tripId: IRecordId,
): Promise<{ success: boolean; message: string }> => {
  const url = `${SEGMENT_MOBILITY_MANAGEMENT}/${agencyId}/trips/${tripId}/mobilities`;
  return request({
    url,
    method: httpVerbs.POST as Method,
    data,
  });
};
